
import {Vue, Component, Emit, Prop, Watch} from 'vue-property-decorator';

import formHelper from '../js/classes/classes.helper';

@Component
export default class Import extends Vue {
    @Prop() private schoolId!: string;

    @Prop() private getClassList!: Function;
    @Prop() private getStudentList!: Function;
    @Prop() private getList!: Function;

    //===================================data区域begin
    uploadHeaders: any = {};
    uploadPath: any = '/api/v1/user/batch';
    dialogTipsVisible: boolean = false; //导入操作模态框
    isImportingModalSuccess: boolean = false; //导入成功提示模态框
    isImportingModalError: boolean = false; //导入失败提示模态框
    isImportingModalErrorDetail: boolean = false; //导入失败提示详情模态框
    uploadData: any = {}; //上传所需参数
    isImportLoading: boolean = false;
    isNormalError: boolean = false; //是否是表格超过200行或模板错误的报错
    isReimport: boolean = true; //重新导入标识符
    isTemplateError: boolean = false; // 模板
    sameNickNameList: boolean = false; //模板姓名是否与平台数据重复
    pwdExeed: boolean = false; //错误详情返回的 password 是否超过指定数值

    count: number = 3;
    importSuccessNum: any = 0;
    importErrorNum: any = 0;
    classId: any = 0;

    //错误详情表格
    columns: any = formHelper.errorColunms;
    errorRows: any = []; //错误详情数据
    //===================================data区域end

    //===================================computed区域begin
    //模板下载地址
    get templatePath() {
        return `/public/v1/user/excel`;
    }
    //===================================computed区域end

    //===================================methods区域begin
    importStudent() {
        this.classId = window.localStorage.getItem('classId');

        let me = this;
        // console.log('上传地址：' + me.uploadPath);
        me.dialogTipsVisible = true;
        me.uploadData = {
            classId: this.classId,
            schoolId: this.schoolId
        };
    }

    //取消模态框回调
    onCancel() {
        this.isImportLoading = false;
    }
    //关闭错误详情模态框回调
    onCancelDetail() {}
    //导入名单
    handleChange(info: any) {
        // console.log(info);
        // console.log(info.file.status);
        if (info.file.status == 'error') {
            this.$nextTick(() => {
                this.onCancel();
                this.dialogTipsVisible = false;
            });
            this.$message.error('导入失败，请重试！');
        }
        if (info.file.status !== 'done') {
            this.isImportLoading = true;
        }
        if (info.file.status === 'done') {
            this.isImportLoading = false;
            // console.log(info.file.response);
            // 模板表格不合法或者超过200行错误
            if (info.file.response.error) {
                // this.$message.error(info.file.response.error);
                //模板错误
                if (info.file.response.code == 90013) {
                    this.isTemplateError = true;
                } else {
                    //超过200行
                    this.isTemplateError = false;
                }
                this.dialogTipsVisible = false;
                this.isImportLoading = false;
                this.isNormalError = true;
                this.isImportingModalError = true;
            } else {
                //上传成功
                if (info.file.response.data.saveCount != 0) {
                    this.$message.success('学生账号已生成');
                    this.importSuccessNum = info.file.response.data.saveCount;
                    this.controlModal();
                    if (this.getClassList && this.getStudentList) {
                        this.getClassList();
                        this.getStudentList();
                    }
                    if (this.getList) {
                        this.getList();
                    }
                } else {
                    this.isNormalError = false;
                    // 重名、密码不合法、性别不合法错误
                    this.dialogTipsVisible = false;
                    this.isImportLoading = false;
                    this.isImportingModalError = true;
                    //存在导入问题的学生个数
                    this.importErrorNum = info.file.response.data.irregularDataList.length;
                    this.errorRows = info.file.response.data.irregularDataList;
                    //对返回的errors编码进行转换
                    for (let i = 0; i < info.file.response.data.irregularDataList.length; i++) {
                        for (let j = 0; j < info.file.response.data.irregularDataList[i].errors.length; j++) {
                            if (info.file.response.data.irregularDataList[i].errors[j] == 90009) {
                                info.file.response.data.irregularDataList[i]['nicknameErr'] = '学生姓名';
                            } else if (info.file.response.data.irregularDataList[i].errors[j] == 90010) {
                                info.file.response.data.irregularDataList[i]['passwordErr'] = '登录密码';
                            } else if (info.file.response.data.irregularDataList[i].errors[j] == 90011) {
                                info.file.response.data.irregularDataList[i]['sexErr'] = '性别';
                            } else if (info.file.response.data.irregularDataList[i].errors[j] == 90014) {
                                info.file.response.data.irregularDataList[i]['tableSameNicknameErr'] = '学生姓名';
                            } else if (info.file.response.data.irregularDataList[i].errors[j] == 90015) {
                                info.file.response.data.irregularDataList[i]['sameNicknameErr'] = '学生姓名';
                            }
                        }
                    }
                    //初始化状态
                    this.sameNickNameList = false;
                    this.pwdExeed = false;
                    for (let i = 0; i < info.file.response.data.irregularDataList.length; i++) {
                        //返回的错误信息是否有与平台学生姓名重名
                        if (info.file.response.data.irregularDataList[i].sameNicknameErr) {
                            this.sameNickNameList = true;
                        }

                        //返回的密码信息长度是否大于设置数值
                        if (info.file.response.data.irregularDataList[i].password?.length > 15) {
                            this.pwdExeed = true;
                        }
                    }
                    //对表格中的 columns进行操作以控制该列是否显示
                    if (!this.sameNickNameList && this.columns[2].title == '平台学生姓名') {
                        this.columns.splice(2, 1);
                    } else if (this.sameNickNameList && this.columns[2].title != '平台学生姓名') {
                        this.columns.splice(2, 0, {
                            dataIndex: 'platformSameName',
                            title: '平台学生姓名',
                            width: '120px',
                            scopedSlots: {
                                customRender: 'platformSameName'
                            }
                        });
                    }

                    //对登录密码列进行操作，以实现改变登录密码列宽度
                    if (this.pwdExeed && this.columns[2].title == '登录密码') {
                        this.columns[2].width = '27%';
                    } else if (this.pwdExeed && !(this.columns[2].title == '登录密码')) {
                        this.columns[3].width = '27%';
                    } else if (!this.pwdExeed && this.columns[2].title == '登录密码') {
                        this.columns[2].width = '17%';
                    } else if (!this.pwdExeed && !(this.columns[2].title == '登录密码')) {
                        this.columns[3].width = '17%';
                    }
                }
            }
        }
    }
    //重新导入名单
    handleRechange(info: any) {
        this.isImportingModalError = false;
        this.dialogTipsVisible = true;
        this.handleChange(info);
    }
    //提示
    handleExceed(files: any, fileList: any) {
        this.$message.error('请勿上传多个文件');
    }
    //关闭
    handleClose() {
        let me = this;
        me.dialogTipsVisible = false;
    }
    controlModal() {
        this.dialogTipsVisible = false;
        this.isImportLoading = false;
        this.isImportingModalSuccess = true;

        // console.log(document.querySelector('.close-num'));
        let num = this.count;

        let timer = setInterval(() => {
            num--;
            document.getElementsByClassName('close-num')[0].innerHTML = num.toString();
            if (num <= 0) {
                clearInterval(timer);
                this.handleCancel();
                document.getElementsByClassName('close-num')[0].innerHTML = this.count.toString();
            }
        }, 1000);
    }
    //关闭导入成功模态框
    handleCancel() {
        this.isImportingModalSuccess = false;
    }
    // 关闭导入失败超过200行模态框
    handleCancelError() {
        this.isImportingModalError = false;
    }
    //关闭导入失败详情模态框
    handleCancelDetail() {
        this.isImportingModalErrorDetail = false;
    }
    viewDetail() {
        this.isImportingModalErrorDetail = true;
        // console.log(this.columns);

        // console.log(document.getElementsByName('th'));
    }
    //===================================methods区域end

    created() {
        let me = this;
        let user = this.$app.getState();
        this.uploadHeaders['Authorization'] = 'Bearer ' + user.token;
        // console.log(this.uploadHeaders['Authorization']);
    }
}
